import { createFileRoute } from '@tanstack/react-router'

import { PlatformAdminConsumerStatusPage } from '../../../../components/pages/backoffice/platform/platform-admin-consumer-status-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/consumer-status')({
  component: () => (
    <PermissionChecker requiredPermissions={['tech.configurations']}>
      <PlatformAdminConsumerStatusPage />
    </PermissionChecker>
  ),
})
